import React, { Component } from 'react';
import { Form, Input, Button, Card, message } from 'antd';

import homeApi from '../api/home';

export default class Lists extends Component {

	constructor(props){
		super(props);
		let jwtToken = window.localStorage.getItem('jwtToken');
	    if (jwtToken) {
	        var timestamp =new Date().getTime()
			window.location.href = "/list?timestamp=" + timestamp
	    }
	}

	render(){

		const layout = {
			labelCol: {
				span: 8,
			},
			wrapperCol: {
				span: 12,
			},
		};

		const tailLayout = {
			wrapperCol: {
				offset: 8,
				span: 16,
			},
		};

		const login = ( values ) => {
			// 接口
			homeApi.login( response => {
				if(response && response.data && response.data.status == "ok"){
					// jwtToken
					let jwtToken = response.data.token;
					window.localStorage.setItem('jwtToken', jwtToken);
					message.success({
					    content: '登录成功',
					    style: {
					      	marginTop: '20vh',
					    },
					    duration: 1,
					}).then(() => {
						var timestamp =new Date().getTime()
				    	window.location.href = "/list?timestamp=" + timestamp
				    });
				}else{
					message.error({
					    content: '登录失败',
					    style: {
					      	marginTop: '20vh',
					    },
					    duration: 1,
					});
				}

			}, values);
		}

		const onFinish = (values) => {
			message.loading({
			    content: '正在登录中..',
			    style: {
			      	marginTop: '20vh',
			    },
			    duration: 1,
			}).then(() => {
		    	login(values)
		    });
		};

		return (
			<div id="home">
	            <div class="login">
					<Card>
						<Form
					      {...layout}
					      onFinish={onFinish}
					    >
							<Form.Item
								name="mobile"
								class="mobile"
								rules={[{ required: false, message: '请输入手机号 !' }]}
							>
								<Input />
							</Form.Item>

							<div class="password">
								<Form.Item
									name="password"
									class="password"
									rules={[{ required: false, message: '请输入密码!' }]}
								>
									<Input.Password />
								</Form.Item>
							</div>

							<div class="index_button">
								<Form.Item {...tailLayout}>
									<Button htmlType="submit">
									</Button>
								</Form.Item>
							</div>
					    </Form>
				    </Card>
			    </div>
			</div>
		)
	}
}